import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=281e659c&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=ts&"
export * from "./TaskDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=281e659c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e659c",
  null
  
)

/* custom blocks */
import block0 from "./TaskDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports